var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[(_vm.hasCard && !_vm.loading)?_c('PaymentInformation'):_vm._e(),(!_vm.hasCard && !_vm.loading)?_c('CardNew',{attrs:{"user":_vm.getUser()}}):_vm._e(),(_vm.loading)?_c('Spinner'):_vm._e(),_c('ErrorDialog',{ref:"errDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }